import {
  AddOutlined,
  FormatListBulletedOutlined,
  RefreshOutlined,
} from "@material-ui/icons";
import {
  Avatar,
  Box,
  Button,
  CardHeader,
  Grid,
  IconButton,
  LinearProgress,
} from "@mui/material";
import { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { frFR } from "@mui/x-data-grid/locales";
import useToast from "../../../../hooks/useToast";
import useConfirmation from "../../../../hooks/useConfirmation";
import { getBackendProfilePictureLink } from "../../../../Helpers/utilsHelper";
import AssignerMembreAssociationParLot from "./AssignerMembreAssociationParLot";
import AppButton from "../../shares/AppButton";
import { MembreParLotService } from "../../../../service/MembreParLotService";
import { useQuery } from "../../../../hooks/useQuery";
import { useNavigate } from "react-router-dom";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import useCrudApi from "../../../../hooks/useCrudApi";
import { AMIService } from "../../../../service/AMI/AMIService";
import AppTypography from "../../shares/reusable/AppTypography";

const ListeMembreAssociationParLot = ({ currentAssociation }) => {
  const [membres, setMembres] = useState([]);
  const { Toast, showToast } = useToast();
  const [dataLoading, setDataLoading] = useState(false);
  const [openSelectMembre, setOpenSelectMembre] = useState(false);
  const { DialogComponent, openConfirmDialog } = useConfirmation();
  const [selectedLotID, setSelectedLotID] = useState(null);
  const navigate = useNavigate();
  const query = useQuery();
  const amiApi = useCrudApi(AMIService);
  const handleFetchMembres = (currentAssociation) => {
    // if (!currentAssociation.uuid) return;
    setDataLoading(true);
    MembreParLotService.liste({ id_type: query.get("job_id") })
      .then((res) => {
        if (res && res.data) {
          setMembres(res.data);
        }
      })
      .finally(() => {
        setDataLoading(false);
      });
  };

  const handleNavigateToMembreForm = (membre) => {
    navigate(
      `/mes-demandes/details/association-membre-form?uuid_membre=${membre.uuid}&job_id=${query.get("job_id")}&cat=${membre.role_responsable}`,
    );
  };

  const handleShowMembreDetail = (membre) => {
    navigate(`association-membre?ref=${membre.id_responsable}`);
  };

  const table_colonne = [
    {
      field: "membre_pdp",
      headerName: "",
      minWidth: 50,
      flex: 0.25,
      renderCell: (params) => {
        return (
          <Grid>
            <Avatar
              sx={{
                m: 1,
                width: "clamp(20px, 15vw, 40px)",
                height: "clamp(20px, 15vw, 40px)",
                fontSize: "clamp(10px, 8vw, 18px)",
              }}
              alt={String(params.row.membre_nom).toUpperCase() || "Asso"}
              src={getBackendProfilePictureLink(params.row.photo)}
            />
          </Grid>
        );
      },
    },
    {
      field: "nom",
      headerName: "Nom",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "prenoms",
      headerName: "Prenoms",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "role_responsable",
      headerName: "Fonction",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "telephone1",
      headerName: "Telephone ",
      flex: 1,
      minWidth: 120,
    },
    /* {
      field: "",
      headerName: "Action",
      minWidth: 150,
      renderCell: (params) => {
        return (
          <Grid justifyContent={"space-around"}>
            <Button
              size="small"
              variant="contained"
              color="primary"
              title="Remplir formulaire pour les membre"
              onClick={(e) => handleNavigateToMembreForm(params.row)}
            >
              Formulaire
            </Button>
          </Grid>
        );
      },
    }, */
  ];

  useEffect(() => {
    handleFetchMembres();
  }, [currentAssociation]);

  useEffect(() => {
    if (query.get("job_id")) {
      amiApi.findOne(query.get("job_id"));
    }
  }, [query.get("job_id")]);

  const handleAddMembre = () => {
    handleOpenSelectMembre(selectedLotID);
  };

  const handleOpenSelectMembre = (id_lot) => {
    setOpenSelectMembre(true);
    setSelectedLotID(id_lot);
  };

  const handleCloseSelectMembre = () => {
    setOpenSelectMembre(false);
    handleFetchMembres(currentAssociation);
  };

  return (
    <>
      <AssignerMembreAssociationParLot
        selectedLotID={selectedLotID}
        open={openSelectMembre}
        onFormClose={handleCloseSelectMembre}
      />
      <DialogComponent />
      <Toast />
      <CardHeader
        title={
          <AppTypography
            titre={amiApi.data.findOneById?.data.libelle_type}
            text={
              `Membres associé - ${amiApi.data.findOneById?.data.libelle_type.substring(0, 40)} ` +
              (amiApi.data.findOneById?.data.libelle_type.length > 40
                ? '...'
                : '')
            }
            loading={amiApi.loading.findOneById}
            variant="h5"
          />
        }
        titleTypographyProps={{ variant: "h5" }}
        avatar={
          <Grid>
            <IconButton onClick={(e) => handleFetchMembres(currentAssociation)}>
              <RefreshOutlined />
            </IconButton>
          </Grid>
        }
        action={
          <Grid>
            <AppButton
              text="Ajouter"
              onClick={handleAddMembre}
              variant="outlined"
              icon={<AddOutlined />}
            />
          </Grid>
        }
      />
      <Grid sx={{ overflowX: "auto", width: "100", height: "35vh" }}>
        <Box display={dataLoading ? "" : "none"} sx={{ width: "100%" }}>
          <LinearProgress />
        </Box>
        <DataGrid
          sx={{
            width: {
              xs: "85.5vw",
              sm: "90vw",
              md: "93.5vw",
              lg: "100%",
            },
            height: "100vh",
          }}
          autoHeight
          getRowId={(row) => row.uuid}
          localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
          columns={table_colonne}
          rows={membres}
        />
      </Grid>
    </>
  );
};

export default ListeMembreAssociationParLot;
